<template>
  <div :class="{ 'places-dialog-opened': state.placesDialogOpened }">

    <Modal
      v-show="isModalVisible"
      v-bind:headerImageName="modal.header_image_name"
      @close="closeModal"
    >
      <div slot="header" v-html="modal.header_html"></div>
      <div slot="body" v-html="modal.body_html"></div>
      <div slot="footer" v-html="modal.footer_html"></div>

    </Modal>

    <div class="container" style="padding-left:0;padding-right:0;">
      <VirtualSearchBox />
      <Places />
      <div class="wrapper">
        <fixed-header :threshold="0">
          <div class="top">
            <div class="top-inner">
              <ViewSwitchComponent />
            </div>
          </div>
        </fixed-header>
        <div class="wrapper-inner">
          <ais-configure
            :facetingAfterDistinct="true"
            :clickAnalytics="true"
            :analyticsTags="['web-slp']"
            :hitsPerPage="hitsPerPage()"
            :getRankingInfo="true"
          />
          <div class="hidden-small sidebar-spacer" />
          <SideBar class="hidden-small" />
          <SideBar
            v-if="state.activeView === 'Filters'"
            class="sidebar-mobile"
          />
          <div :class="['main', state.activeView]">
            <SearchResults>
              <div>
                <Results
                  :store="state"
                  :type="state.activeView"
                  @modalInterface="showModal"
                  v-if="
                    state.activeView === 'Grid' || state.activeView === 'List'
                  "
                />
                <div v-if="state.activeView === 'Map'">
                  <Map
                    :store="state"
                    @modalInterface="showModal"
                  />
                </div>
              </div>
            </SearchResults>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import FixedHeader from 'vue-fixed-header';
import Results from './Results.vue';
import SearchResults from './SearchResults.vue';
import SideBar from './SideBar.vue';
import ViewSwitchComponent from './ViewSwitchComponent.vue';
import Map from './Map.vue';
import Places from './Places';
import VirtualSearchBox from './VirtualSearchBox';
import Modal from './Modal.vue';
import { store } from '../store';

export default {
  components: {
    FixedHeader,
    Results,
    SearchResults,
    SideBar,
    ViewSwitchComponent,
    Map,
    Places,
    VirtualSearchBox,
    Modal
  },
  data() {
    return {
      state: store.state,
      isModalVisible: false,
      modalType: 'default', // Possible values: user_login_required/valid_membership_required
      modal: [
        {
          type: "default",
          header_image_name: 'auth-modal-header-login-required.png',
          header_html: '<div class="modal-header-row"><h3>This is default modal heading.</h3></div>',
          body_html: "<p>This is default modal text.</p>",
          footer_html: '<a href="./example1.php" class="btn btn-dark text-uppercase-spaced">Example Button 1</a><a href="./example2.php" class="btn btn-outline-dark text-uppercase-spaced">Example Button 2</a>',
        }
      ],
      modals: [
        {
          type: "user_login_required",
          header_image_name: 'auth-modal-header-login-required.png',
          header_html: '<div class="modal-header-row"><h3>Login.</h3></div>',
          body_html: "<p>This offer is only available to<br />gourmet society members.</p>",
          footer_html: '<a href="./login.php?source_url='+(location.pathname+location.search)+'" class="btn btn-dark text-uppercase-spaced">Login</a><a href="./purchase.php" class="btn btn-outline-dark text-uppercase-spaced">Join Now</a>',
        },
        {
          type: "valid_membership_required",
          header_image_name: 'auth-modal-header-valid-membership-required.png',
          header_html: '<div class="modal-header-row"><h3>Login.</h3></div>',
          body_html: "<p>This offer is only available to<br />gourmet&nbsp;society members with a valid membership.</p>",
          footer_html: '<a href="./purchase.php" class="btn btn-dark text-uppercase-spaced">Add Membership</a><a href="./purchase.php" class="btn btn-outline-dark text-uppercase-spaced">Join</a>',
        }
      ]
    };
  },
  computed: {},
  methods: {
    hitsPerPage() {
      if (this.state.activeView === 'Map') {
        return 60;
      } else {
        // divisible by 2, 3, 4 so it flows nicely on all views
        return 24;
      }
    },
    closeModal() {
      this.isModalVisible = false;
    },
    showModal(modalType) {
      // console.log('reemition back to parent component AlgoliaSearch (showModal)');
      // console.log('passed modalType: ' + modalType);
      // console.log('test data from modals array: ' + this.modals[0].header_image_name);
      var modals = this.modals;
      for (let i=0; i < modals.length; i++){
        if (modals[i].type == modalType){
          this.modal = modals[i];
        }
      }
      this.isModalVisible = true;
    },
  },
  // vue equivalent of document ready (?)
  mounted() {
    this.$nextTick(function () {
      // allowing access to showModal method
      let showModal = this.showModal;
      // catching evnt sent from algolia.autocomplete.js
      window.addEventListener('showModalExt', function(e){ showModal(e.detail.modal.type) });
    })
  },
  // remove evnet listener when AlgoliaSearch is destroyed
  destroyed() {
    let closeModal = this.closeModal;
    window.removeEventListener('showModalExt', function(){ closeModal() });
  }
};
</script>






<style lang="scss" scoped>
.hidden-small {
  display: none;

  @media (min-width: $tablet + 1) {
    display: block;
  }
}

.top {
  padding: 18px 0 0;
  position: fixed;
  top: 104px;
  left: 0;
  width: 100%;
  background: white;
  z-index: 100;

  @media (max-width: $tablet) {
    .search-boxes-closed & {
      top: 54px;
    }

    &.vue-fixed-header--isFixed {
      top: 0;
    }

    top: 160px;
  }

  .top-inner {
    margin: auto;
    float:right;
    margin-right:5%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media screen and (max-width: 860px) {
      flex-direction: column-reverse;
    }
  }

  &.vue-fixed-header--isFixed {
    box-shadow: 0 0px 9px rgba(0, 0, 0, 0.3);

    @media screen and (max-width: $tablet) {
      left: 0;
      width: 100%;
    }
  }
}

.wrapper {
  width: 100%;
  padding: 190px 0 0;

  @media screen and (max-width: $desktop) {
    padding: 190px 0 0;
  }
  @media screen and (max-width: $tablet) {
    padding: 18px 0 0;
  }
  &-inner {
    display: flex;
    width: 100%;

    @media screen and (max-width: $tablet) {
      padding-top: 75px;
    }
  }
}

.main {
  flex-grow: 1;
  margin: 0 25px;
  min-width: 0;
  @media screen and (min-width: $tablet + 1) {
    // margin-left: calc(400px + 4em);
  }
  @media screen and (max-width: $tablet) {
    margin: 0 15px;

    &.Map {
      margin: 0;
    }
  }

  .sidebar-mobile {
    top: 0;
  }
}

.supermain.vue-fixed-header--isFixed {
  // transform: translateY(200px);
}

.sidebar-spacer {
  position: fixed;
  left: 0;
  top: 190px;
  width: calc(50px + (100vw - 1430px) / 2);
  height: calc(100vh - 200px);
  background: $alabaster-white;
}

.desktop-only {
  @media screen and (max-width: $tablet) {
    display: none;
  }
}

.mobile-only {
  @media screen and (min-width: $tablet + 1) {
    display: none;
  }
}
</style>
